<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">

  <!-- Section header start -->
  <div class="card p-1 mb-2 headerBackground tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <fa-icon class="fas checklistIcon" title="click for smart checklist" (click)="openSmartChecklist()"  [icon]="faCircle">
          </fa-icon>
          <fa-icon class="fab fa-lg autoCursor" [icon]="faConnectdevelop"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize">{{ 'menu.interactionMapper' | translate }}</h6>
      </div>
      <div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6">
        <p class="titleParagraph">{{'interactionMapper.toolHeaderLine1' | translate}}<br>
          {{'interactionMapper.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <table class="dropGroupBtn">
          <tr>
            <td class="iconGroupHeight">
              <span>
                <a id="interactionYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkIM">
                  <fa-icon class="fas autoCursor" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span
                (click)="mainComponent.setDetaultToggleValues('Inter',mainComponent.interactionTFToggleStatus,mainComponent.interactionURToggleStatus,mainComponent.interactionBFToggleStatus,mainComponent.interactionXXToggleStatus)">
                <!-- project.views.open('Imm');interactionMapperMindmap.init();interactionMapperMindmap.controller.resetActiveTab(); -->
                <fa-icon class="fas fa-lg" [icon]="faProjectDiagram" (click)="mainComponent.openTool('interactionMapperMindMap');interactionMapperMindMapComponent.setSelectedYEut('Feature')" routerLink="/main/interactionMapperMindMap">
                </fa-icon>
              </span>
            </td>
          </tr>
          <tr class="bg-color-black">
            <td class="height25px">
              <span (click)="generateReport('true')">
                <fa-icon class="fas  margintop7pxminus" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
          <td rowspan="2">
            <span class="autoCursor " >
              <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
            </span>
          </td>
        </table>
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="interaction-mapper tool-body-height">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="persona-mapper-grid-table-height">
        <div class="row full-width only-bottom-padding card p-1 bg-white h-50">
          <div class="table-responsive">
            <table class="table table-bordered border-none table-sm i-mapper tableBackgrdClrBlack menuItemsClrWhite">
              <tbody>
                <tr class="table-bordered-bottom"
                  [ngClass]="{displayNone:model.interactionMapUI[model.xeutType].length==tabIndex+1}"
                  *ngFor="let p of model.interactionMapUI[model.xeutType]; let tabIndex = index">
                  <!-- *ngIf="!$last" -->
                  <th class="border-right1px border-left1px">
                    <span *ngIf="((model.interactionMapUI[model.xeutType].length==tabIndex+1) || (p.name!=''))">
                     {{p.yindex+1}}
                    </span>
                    <!-- *ngIf="$last||p.name!=''" -->
                  </th>
                  <td class="border-right1px mapperReadOnly" *ngFor="let eut of p.eutList; let tabIndex = index"
                    [ngClass]="{paleyellow:eut.map=='*'}"
                    (click)="(eut.map!=-1 && p.eID!=eut.eID) && mapEUT(p,tabIndex,eut.eID)">
                    <b *ngIf="eut.map!=-1"></b>&nbsp;
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-nonresponsive i-mapper-table">
            <table width="100%" border="0" cellspacing="0" cellpadding="0"
              class="table table-bordered border-none table-sm i-mapper tableBackgrdClrBlack">
              <tbody>
                <tr class="table-bordered-bottom"
                  [ngClass]="{displayNone:model.interactionMapUI[model.xeutType].length!=tabIndex+1}"
                  *ngFor="let p of model.interactionMapUI[model.xeutType]; let tabIndex = index">
                  <!-- *ngIf="$last" -->
                  <th class="border-left1px border-right1px">
                    &nbsp;
                  </th>
                  <td class="fontsize8pxESD border-right1px" *ngFor="let eut of p.eutList; let tabIndex = index"
                    [ngClass]="{dis:eut.map==-1||eut.map!=''}" (click)="scopeMapper.model.update(p,tabIndex,eut.eID)">
                    <span *ngIf="eut.map!=-1">{{eut.map}}</span>&nbsp;
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card p-1 mb-2 bg-white h-50 menuItemsClrWhite">
          <div class="row strict">
            <div class="col-md-12">
              <ul class="nav nav-tabs" role="tablist">
                <li class="dropdown active" id="yAxisActiveTab">
                  <a class="dropdown-toggle" data-toggle="dropdown">
                    (<span>Y</span>)-{{yEutType}}
                    <b class="caret"></b>
                  </a>
                  <ul class="dropdown-menu">
                    <li (click)="setSelectedYEut('Feature');changeAxisTab('yAxis')" id="yAxisFeature">
                      <a ng-attr-data-target="#yeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Fe' | translate}}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'TF'}:filterTypeCount)}})
                      </a>
                    </li>
                    <li (click)="setSelectedYEut('Requirement');changeAxisTab('yAxis')" id="yAxisRequirement">
                      <a ng-attr-data-target="#yeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Ur' | translate}}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount)}})
                      </a>
                    </li>
                    <li (click)="setSelectedYEut('Flow');changeAxisTab('yAxis')" id="yAxisFlow">
                      <a ng-attr-data-target="#yeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Bf' | translate}}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'BF'}:filterTypeCount)}})
                      </a>
                    </li>
                    <li (click)="setSelectedYEut('Unspecified');changeAxisTab('yAxis')" id="yAxisUnspec">
                      <a ng-attr-data-target="#yeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Xx' | translate}}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'XX'}:filterTypeCount)}})
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown" id="xAxisActiveTab">
                  <a class="dropdown-toggle" data-toggle="dropdown">
                    (<span>X</span>)-{{xEutType}}
                    <b class="caret"></b>
                  </a>
                  <ul class="dropdown-menu">
                    <li (click)="setSelectedXEut('Feature');changeAxisTab('xAxis')" id="xAxisFeature">
                      <a ng-attr-data-target="#xeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Fe' | translate }}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'TF'}:filterTypeCount)}})
                      </a>
                    </li>
                    <li (click)="setSelectedXEut('Requirement');changeAxisTab('xAxis')" id="xAxisRequirement">
                      <a ng-attr-data-target="#xeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Ur' | translate}}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount)}})
                      </a>
                    </li>
                    <li (click)="setSelectedXEut('Flow');changeAxisTab('xAxis')" id="xAxisFlow">
                      <a ng-attr-data-target="#xeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Bf' | translate}}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'BF'}:filterTypeCount)}})
                      </a>
                    </li>
                    <li (click)="setSelectedXEut('Unspecified');changeAxisTab('xAxis')" id="xAxisUnspec">
                      <a ng-attr-data-target="#xeut1" role="tab" data-toggle="tab">
                        {{ 'entities.Xx' | translate}}&nbsp;
                        ({{(modelData.listOfEUTs|landscaperEntity:{eType:'XX'}:filterTypeCount)}})
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <!-- Tab panes -->
          <div class="tab-content mb-0 interaction-nav-tab-table-height">

            <div class="tab-pane active h-100 overflowYTextAuto" ng-attr-id="xeut1"
              [ngClass]="{ 'active':mapAciveAxisType==='xAxis'}">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.xeutType)" class="list-group">
                <div class="alert alert-warning">
                  <strong>
                    <div style="text-align: center;">
                      No
                      {{getEntityType(model.xeutType) | lowercase}}
                      defined.
                    </div>
                  </strong>
                </div>
              </ul>
              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack" *ngIf="entityExists(model.xeutType)">
                <thead class="w-100" *ngIf="entityExists(model.xeutType)">
                  <tr class="row strict border-bottom1px">
                    <th class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1"></th>
                    <th class="col-xs-9">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody id="list-of-xeut" class="toolEntityTBody">
                  <!-- *ngFor="let p of model.personaMapUI[model.eutType]; let tabIndex = index" -->
                  <tr class=" row strict border-bottom1px" *ngFor="let eut of pagedItems; let tabIndex = index">
                    <!-- ng-repeat="eut in yeutCollection[model.xeutType] |limitTo : model.listLength:model.xstartAt" -->
                    <td class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input type="checkbox" class="checkboxReadOnly" [checked]="isCheckedX(eut.eID)"
                          (click)="toggleSelectionX(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1">
                      {{xeutCollection[model.xeutType].indexOf(eut)+1}}
                    </td>
                    <td class="col-xs-9">{{getModuleName(eut)}} | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane h-100 overflowYTextAuto" ng-attr-id="yeut1"
              [ngClass]="{ 'active':mapAciveAxisType==='yAxis'}">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.yeutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      No {{getEntityType(model.yeutType) | lowercase}}
                      defined.
                    </div>
                  </strong>
                </div>
              </ul>
              <table class="table env1 h-100 mb-0 tableBackgrdClrBlack" *ngIf="entityExists(model.yeutType)">
                <thead class="w-100" *ngIf="entityExists(model.yeutType)">
                  <tr class=" row strict border-bottom1px">
                    <th class="col-xs-1">
                      <div style="text-align: center;">
                        <input type="checkbox" class="readOnlyFormPlanner" [checked]="isAllSelectedY()"
                          (click)="toggleAllDeselectY($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1"></th>
                    <th class="col-xs-9">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody id="list-of-yeut" class="toolEntityTBody">
                  <!-- *ngFor="let p of model.personaMapUI[model.eutType]; let tabIndex = index" -->
                  <tr class="row strict border-bottom1px" *ngFor="let eut of pagedItems; let tabIndex = index">
                    <!-- ng-repeat="eut in yeutCollection[model.yeutType] |limitTo : model.listLength:model.ystartAt" -->
                    <td class="col-xs-1">
                      <div style="text-align: center;">
                        <input type="checkbox" class="readOnlyFormPlanner" [checked]="isCheckedY(eut.eID)"
                          (click)="toggleSelectionY(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1">
                      <!-- *ngIf="selectedEUT.eID != eut.eID" -->
                      {{yeutCollection[model.yeutType].indexOf(eut)+1}}
                    </td>
                    <td class="col-xs-9">
                      <!-- *ngIf="selectedEUT.eID != eut.eID" -->
                      {{getModuleName(eut)}} | {{eut.eName}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="model.xTabValid" class="row entity-row">
        <div style="text-align: center;">
          <div class="btn-group" role="group">
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }" (click)="firstPage();setPage(1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepBackward"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }"
              (click)="previousPage();setPage(pager.currentPage - 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleLeft"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="nextPage();setPage(pager.currentPage + 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleRight"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="lastPage();setPage(pager.totalPages)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepForward"></fa-icon>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="!model.xTabValid" class="row entity-row">
        <div style="text-align: center;">
          <div class="btn-group" role="group">
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUpY }" (click)="firstPageY();setPage(1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepBackward"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUpY }"
              (click)="previousPageY();setPage(pager.currentPage - 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleLeft"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDownY }"
              (click)="nextPageY();setPage(pager.currentPage + 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleRight"></fa-icon>
            </button>
            <button class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDownY }"
              (click)="lastPageY();setPage(pager.totalPages)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepForward"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="interactionmapperTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #1 : {{'interactionMapper.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #2 : {{'interactionMapper.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #3 : {{'interactionMapper.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#interactionmapperTip"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#interactionmapperTip"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- Youtube video Modal -->
  
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkIM" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkIM" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{'youtubeVideoTitle.interactionmapper' | translate}}
            </h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="ImVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>